<template>
  <div>
    <ExportPdf :id="$route.query.id" />
    <WalletPay
      :id="$route.query.id"
      :idet="invoiceDetails"
      :company="company"
    />
    <MasterLayout>
      <div class="py-4 dashboard_first_row">
        <div class="invoice_edit_del_cont">
          <!-- <div
            class="bold-span grey-text flex"
            style="
              color: red !important;
              display: flex !important;
              flex-direction: row; !important;
            "
          >
            Wallet Balance: <span class="bold-span">₦</span
            >{{ invoiceDetails.walletBalance }}
          </div> -->

          <div>
            <button
              class="invoice_btn edit_invoice bg-success text-light"
              v-if="invoiceDetails.status !== 'Paid'"
              @click="makePayment"
            >
              {{ $t("text.cInvoice.details.makePayment") }}
            </button>
            <router-link
              :to="{
                name: 'invoice_payments',
                query: {
                  id: $route.query.id,
                  companyId: $route.query.companyId,
                },
              }"
              class="invoice_btn edit_invoice"
            >
              {{ $t("text.cInvoice.details.invoicePayment") }}</router-link
            >
            <button class="invoice_btn" @click="downloadPdf">
              {{ $t("text.cInvoice.details.exportPDF") }}
            </button>
          </div>
        </div>
        <div class="dialog-container" style="width: 80%">
          <div class="row">
            <div class="col-md-6">
              <div class="row align-items-center">
                <div class="col-md-3">
                  <div>
                    <span>{{ $t("text.cInvoice.status") }}</span>
                  </div>
                  <div>
                    <div
                      class="invoice-status bold-span overdue"
                      :class="[
                        invoiceDetails.status === 'OverDue'
                          ? 'danger'
                          : invoiceDetails.status === 'Draft'
                          ? 'success'
                          : invoiceDetails.status === 'Paid'
                          ? 'paidColor'
                          : 'yelloInvoiceColor',
                      ]"
                    >
                      {{ invoiceDetails.status }}
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div>
                    <span>{{ $t("text.cInvoice.customer") }}</span>
                  </div>
                  <div>
                    <span class="bold-span">{{
                      invoiceDetails.customerName
                    }}</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <div>
                    <span> {{ $t("text.cWallet.walletBalance") }}</span>
                  </div>
                  <div>
                    <!-- <span class="bold-span"
                      >{{ company ? company.currencyCode : ""
                      }}{{
                        convertThousand(invoiceDetails.walletBalance)
                      }}</span
                    > -->
                    <span class="bold-span"
                      >{{ invoiceDetails.walletUnit
                      }}{{
                        convertThousand(invoiceDetails.walletBalance)
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="text-right col-md-6">
              <div class="row align-items-center">
                <div class="col-md-6">
                  <div>
                    <span> {{ $t("text.cInvoice.amountDue") }}</span>
                  </div>
                  <div>
                    <span class="bold-span">{{
                      invoiceDetails.walletUnit
                    }}</span
                    ><span class="bold-span">{{
                      convertThousand(invoiceDetails.amountDue)
                    }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div>
                    <span class=""> {{ $t("text.cInvoice.du") }}</span>
                  </div>
                  <div>
                    <span class="bold-span">{{
                      timeSince(new Date(invoiceDetails.invoiceDueDate))
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-3 preview-container">
              <div class="pb-4 row ivoice-preview-header-wrapper">
                <div class="text-right col-md-12">
                  <div class="pt-3 pr-3 e-heading--title">
                    {{ invoiceDetails.invoiceTitle }}
                  </div>
                  <div class="pr-3 e-heading--subtitle">
                    <h5 class="bold-span">
                      {{ invoiceDetails.invoiceDescription }}
                    </h5>
                  </div>
                  <div class="pr-3 e-heading--subtitle">
                    {{ $t("text.cInvoice.fuelMetrics") }}
                  </div>
                  <div class="pt-2 pr-3 e-heading--para">
                    {{ $t("text.cInvoice.nigeria") }}
                  </div>
                </div>
              </div>
              <div class="row justify-content-space-between">
                <div class="col-md-7">
                  <div
                    class="p-3 invoice_customer"
                    v-if="invoiceDetails.customerName"
                  >
                    <div class="bold-span grey-text">
                      {{ $t("text.cInvoice.details.billTo") }}
                    </div>
                    <div class="mt-1 bold-span">
                      {{ invoiceDetails.customerName }}
                    </div>
                    <div class="mt-1 bold-span">
                      {{ invoiceDetails.customerMail }}
                    </div>
                  </div>
                  <!-- <div class="p-5 invoice_customer" v-if="!invoiceDetails.customerName">
                                        You have not added a customer
                                    </div> -->
                </div>
                <div class="col-md-5">
                  <div class="pt-3 row align-items-center">
                    <div class="text-right col-md-5">
                      <label class="primary-color"
                        >{{ $t("text.cInvoice.details.invoiceNum") }}:
                      </label>
                    </div>
                    <div class="col-md-7">
                      <div class="">
                        {{ invoiceDetails.invoiceNumber }}
                      </div>
                    </div>
                  </div>
                  <div class="mt-1 row align-items-center">
                    <div class="text-right col-md-5">
                      <label class="primary-color">{{
                        $t("text.cInvoice.details.invoiceDate")
                      }}</label>
                    </div>
                    <div class="col-md-7">
                      <div class="">
                        <small class="bold-span">{{
                          $moment(invoiceDetails.invoiceDate).format(
                            "DD MMMM YYYY",
                          )
                        }}</small>
                      </div>
                    </div>
                  </div>
                  <div class="mt-1 row align-items-center">
                    <div class="text-right col-md-5">
                      <label class="primary-color"
                        >{{ $t("text.cInvoice.details.paymentDue") }}:
                      </label>
                    </div>
                    <div class="col-md-7">
                      <div class="">
                        <small class="bold-span">{{
                          $moment(invoiceDetails.invoiceDueDate).format(
                            "DD MMMM YYYY",
                          )
                        }}</small>
                      </div>
                    </div>
                  </div>
                  <div class="mt-1 row align-items-center">
                    <div class="text-right col-md-5">
                      <label class="primary-color"
                        >{{ $t("text.cInvoice.amountDue") }}:</label
                      >
                    </div>
                    <div class="col-md-7">
                      <div class="bold-span">
                        {{ invoiceDetails.walletUnit }}
                        {{ convertThousand(invoiceDetails.amountDue) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-2 pl-3 pr-3 mt-2 preview-table header">
                <div class="invoice_item_name">
                  <span class="text-white">{{
                    $t("text.cInvoice.details.items")
                  }}</span>
                </div>
                <div class="invoice_item_quantity">
                  <span class="text-white">{{
                    $t("text.cInvoice.details.quantity")
                  }}</span>
                </div>
                <div class="invoice_item_price">
                  <span class="text-white">{{
                    $t("text.cInvoice.details.price")
                  }}</span>
                </div>
                <div class="text-right invoice_item_total">
                  <span class="text-white">{{
                    $t("text.cInvoice.details.amount")
                  }}</span>
                </div>
              </div>
              <div
                v-if="
                  invoiceDetails.invoiceItems &&
                  invoiceDetails.invoiceItems.length
                "
              >
                <div
                  class="mt-2"
                  v-for="(prod, i) in invoiceDetails.invoiceItems"
                  :key="i"
                >
                  <div class="p-2 pl-3 pr-3 preview-table">
                    <div class="invoice_item_name">
                      <span class="primary-color">{{ prod.itemName }}</span>
                      <span class="item_description">{{
                        prod.itemDescription
                      }}</span>
                    </div>
                    <div class="invoice_item_quantity">
                      <span class="primary-color">{{ prod.itemQuantity }}</span>
                    </div>
                    <div class="invoice_item_price">
                      <span class=""
                        >{{ invoiceDetails.walletUnit
                        }}{{ convertThousand(prod.itemPrice) }}</span
                      >
                    </div>
                    <div class="invoice_item_total">
                      <span class=""
                        >{{ invoiceDetails.walletUnit
                        }}{{
                          convertThousand(prod.itemPrice * prod.itemQuantity)
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="p-3 mt-2 text-center font-italic"
                v-if="
                  invoiceDetails.invoiceItems &&
                  !invoiceDetails.invoiceItems.length
                "
              >
                {{ $t("text.cInvoice.details.noItem") }}
              </div>
              <div class="pr-3 mt-3 text-right">
                <span class="mr-3 primary-color">
                  {{ $t("text.cInvoice.details.subTotal") }}:
                </span>
                <span class="primary-color"
                  >{{ invoiceDetails.walletUnit }}
                  {{ convertThousand(subTotalInvoiceItemsPrice) }}</span
                >
              </div>
              <div
                class="pr-3 mt-3 text-right"
                v-for="(value, name, i) in taxObj"
                :key="i"
              >
                <small class="mr-3"
                  >{{ value.name }}({{ value.rate }}%):
                </small>
                <small class=""
                  >{{ invoiceDetails.walletUnit }}
                  {{ convertThousand(value.totalAmount) }}
                </small>
              </div>
              <div class="pr-3 mt-2 text-right">
                <span class="mr-3 primary-color">
                  {{ $t("text.cInvoice.details.total") }}:
                </span>
                <span class="primary-color"
                  >{{ invoiceDetails.walletUnit }}
                  {{
                    convertThousand(subTotalInvoiceItemsPrice + taxAmount)
                  }}</span
                >
              </div>
              <div class="pr-3 mt-2 text-right">
                <span class="mr-3 primary-color">
                  {{ $t("text.cInvoice.details.amountPaid") }}:
                </span>
                <span class="primary-color"
                  >{{ invoiceDetails.walletUnit }}
                  {{ convertThousand(amountPaid) }}</span
                >
              </div>
              <hr />
              <div class="pr-3 mt-2 text-right">
                <!-- <span class="mr-3 primary-color bold-span"
                  >{{ $t("text.cInvoice.amountDue") }}({{
                    company ? company.currency : ""
                  }}):
                </span> -->
                <span class="mr-3 primary-color bold-span"
                  >{{ $t("text.cInvoice.amountDue") }}({{
                    invoiceDetails.walletUnit
                  }}):
                </span>
                <span class="primary-color bold-span"
                  >{{ invoiceDetails.walletUnit }}
                  {{ convertThousand(invoiceDetails.amountDue) }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <!-- <div><button @click="getppp">get it</button></div> -->
      </div>
    </MasterLayout>
  </div>
</template>
<script>
import MasterLayout from "@/views/Company/MasterLayout.vue";
import ExportPdf from "@/components/modals/Invoices/exportPdf";
import WalletPay from "@/components/modals/Invoices/walletPay";
import configObject from "@/config";

import Jquery from "jquery";
let $ = Jquery;

export default {
  title: "Invoice Details:: Epump Portal",
  components: {
    MasterLayout,
    ExportPdf,
    WalletPay,
  },
  data() {
    return {
      invoiceItems: [],
      invoiceDetails: {},
      subTotalInvoiceItemsPrice: 0,
      taxAmount: 0,
      taxObj: {},
      amountPaid: 0,
      company: null,
      companyId: null,
      id: null,
      comCountry: null,
      // prevRoute: null,
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     vm.prevRoute = from;
  //     // console.log(from);
  //   });
  // },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
      this.companyId = this.$route.query.companyId
        ? this.$route.query.companyId
        : this.company.id;
      this.id = this.$route.query.id;
      this.comCountry = this.company.country;
    });
    this.getInvoiceDetails();
  },
  methods: {
    // getppp() {
    //   console.log(this.prevRoute);
    // },
    makePayment() {
      // console.log("make payment");
      if (
        this.invoiceDetails.walletBalance <= this.invoiceDetails.amountDue &&
        this.comCountry == "Nigeria"
      ) {
        this.$router.push({
          name: "make_payment",
          query: {
            id: this.id,
            amt: this.invoiceDetails.amountDue,
            companyId: this.companyId,
          },
        });
      } else if (
        this.invoiceDetails.walletBalance <= this.invoiceDetails.amountDue &&
        this.comCountry !== "Nigeria"
      ) {
        this.$router.push({
          name: "make_payment_stripe",
          query: {
            id: this.id,
            amt: this.invoiceDetails.amountDue,
            companyId: this.companyId,
          },
        });
      } else {
        this.$modal.show("walletPay");
      }
    },
    getInvoiceDetails() {
      if (!this.$route.query.id) {
        this.$toast.open({
          message: this.$t("text.bInvoices.noInvoiceSelected"),
          type: "error",
          duration: 5000,
        });
        // this.$router.push({
        //   name: "company_invoice",
        //   query: { companyId: this.$route.query.companyId },
        // });
        return;
      }
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Invoices/${this.$route.query.id}`,
          configObject.authConfig(),
        )
        .then((res) => {
          res.data.status =
            res.data.status == 0
              ? "Draft"
              : res.data.status == 1
              ? "Pending"
              : res.data.status == 2
              ? "Unsent"
              : res.data.status == 3
              ? "OverDue"
              : res.data.status == 4
              ? "Paid"
              : res.data.status == 5
              ? "PartPaid"
              : "Not available";
          this.invoiceDetails = res.data;
          this.subTotalInvoiceItemsPrice = res.data.invoiceItems.reduce(
            (total, cur) => {
              return total + cur.itemPrice * cur.itemQuantity;
            },
            0,
          );

          this.amountPaid = res.data.paymentDetails.reduce((total, cur) => {
            return total + cur.amountPaid;
          }, 0);

          let totalTax = 0;
          let invoiceObj = {};

          res.data.invoiceItems.forEach((cur) => {
            const totalPrice = cur.itemPrice * cur.itemQuantity;

            cur.invoiceTaxes.forEach((tax) => {
              totalTax += (tax.rate / 100) * totalPrice;
              const taxId = tax.taxId;
              if (invoiceObj[taxId]) {
                invoiceObj[taxId]["totalAmount"] =
                  invoiceObj[taxId]["totalAmount"] +
                  (tax.rate / 100) * totalPrice;
              } else {
                invoiceObj[taxId] = {
                  name: tax.taxName,
                  rate: tax.rate,
                  totalAmount: (tax.rate / 100) * totalPrice,
                };
              }
            });
          });

          this.taxAmount = totalTax;
          this.taxObj = invoiceObj;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.statusDescription,
            type: "error",
            duration: 5000,
          });
          this.$router.push({ name: "company_invoice" });
        });
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    downloadPdf() {
      this.$modal.show("exportPdf");
    },

    timeSince(date) {
      let seconds = Math.floor((new Date() - date) / 1000);
      const value = seconds < 0 ? "from now" : "ago";
      seconds = Math.abs(seconds);

      var interval = seconds / 31536000;

      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " year " : " years ") +
          value
        );
      }
      interval = seconds / 2592000;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " month " : " months ") +
          value
        );
      }
      interval = seconds / 86400;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " day " : " days ") +
          value
        );
      }
      interval = seconds / 3600;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " hour " : " hours ") +
          value
        );
      }
      interval = seconds / 60;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " minute " : " minutes ") +
          value
        );
      }
      return (
        Math.floor(seconds) +
        (Math.floor(interval) == 1 ? " second " : " seconds ") +
        value
      );
    },
  },
};
</script>
